import React from "react";
import "./AnalyticsStatCards.scss";
import { useChartTooltip, ChartHoverTooltip } from "./ChartHoverTooltip";

const TruncatedValue = ({ value }) => {
  const { tooltip, showTooltip, hideTooltip } = useChartTooltip();
  const valueString = value.toString();
  const maxDigits = 12;

  if (valueString.length <= maxDigits) {
    return <span>{value}</span>;
  }

  const truncatedValue = valueString.slice(0, maxDigits) + "...";

  return (
    <>
      <ChartHoverTooltip tooltip={tooltip} />
      <span
        style={{ cursor: "pointer" }}
        onMouseEnter={(e) => showTooltip(e, valueString)}
        onMouseLeave={hideTooltip}
      >
        {truncatedValue}
      </span>
    </>
  );
};

const CARDS = [
  {
    key: "total_hospitals",
    title: "Total Facilities",
    icon: "icon-blue",
    src: "/total_facilities.png",
  },
  {
    key: "total_devices",
    title: "Total Devices",
    icon: "icon-purple",
    src: "/total_devices.png",
  },
  {
    key: "total_alerts_generated",
    title: "Total Alerts",
    icon: "icon-red",
    src: "/total_alerts.png",
  },
  {
    key: "total_ctg_sessions",
    title: "Total CTG Sessions",
    icon: "icon-purple",
    src: "/total_ctg_sessions.png",
  },
  {
    key: "total_hours_monitored",
    title: "Total Monitoring Hours",
    icon: "icon-green",
    src: "/total_monitoring_hours.png",
  },
  {
    key: "unique_patients_monitored",
    title: "Unique Patient's Monitored",
    icon: "icon-blue",
    src: "/total_unique_patients.png",
  },
];

function AnalyticsStatCards({ values = {}, isLoading }) {
  return (
    <div className="analytics-stats-container">
      {CARDS.map((card) => (
        <div className="analytics-stat-card" key={card.key}>
          <div className={`analytics-stat-icon ${card.icon}`}>
            <img src={card.src} alt="" />
          </div>
          <div className="analytics-stat-value">
            {isLoading ? (
              <div style={{ color: "#6c757d", fontSize: "14px" }}>
                Loading...
              </div>
            ) : (
              <TruncatedValue value={values[card.key] || 0} />
            )}
          </div>
          <div className="analytics-stat-title">{card.title}</div>
        </div>
      ))}
    </div>
  );
}

export default AnalyticsStatCards;
